module.exports = __webpack_public_path__ + "static/media/logo-sebrae.6c0c28ed.png";